module.exports = __webpack_public_path__ + "static/media/bg-2.86d91a72.jpg";